import { Detail } from './parts/Detail';
import { PetitionsDetailLoader } from './parts/PetitionDetailModalLoader';
import { Button } from '@octano/global-ui';
import { useTexts } from '../../hooks/useTexts';
type Props = {
  petitionId?: number;
  onClose?: () => void;
};
export const PetitionDetailModal = ({ petitionId, onClose }: Props) => {
  const texts = useTexts().detail;

  if (!petitionId) {
    return <></>;
  }
  return (
    <PetitionsDetailLoader petitionId={petitionId}>
      {({ data }) => (
        <>
          <Detail data={data} />
          <div>
            <Button
              className="float-right mr-5"
              text={texts.resume.finish}
              onClick={onClose}
            />
          </div>
        </>
      )}
    </PetitionsDetailLoader>
  );
};
